var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_538_17837",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3689 3.94152L15.8354 0.666016H3.50244L0.960938 3.94152",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.667969 4.66602C0.667969 4.4008 0.773326 4.14645 0.960862 3.95891C1.1484 3.77137 1.40275 3.66602 1.66797 3.66602H17.668C17.9332 3.66602 18.1875 3.77137 18.3751 3.95891C18.5626 4.14645 18.668 4.4008 18.668 4.66602V18.166C18.668 18.5638 18.5099 18.9454 18.2286 19.2267C17.9473 19.508 17.5658 19.666 17.168 19.666H2.16797C1.77014 19.666 1.38861 19.508 1.10731 19.2267C0.826004 18.9454 0.667969 18.5638 0.667969 18.166V4.66602Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.668 11.666L9.66797 15.666L5.66797 11.666M9.66397 7.66602V15.666",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_538_17837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2.33203 -1.83398H21.668V22.166H-2.33203V-1.83398Z",
    fill: "#00A86B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMask);
export default __webpack_public_path__ + "static/media/mask.6475c9705ea28019f24a6504010c36e3.svg";
export { ForwardRef as ReactComponent };